module.exports = __webpack_public_path__ + "media/images/fig_14days-66b324c18c4ef6e9729af5ba0e798894.png";